import type { PlayerStat } from './mockGameDetail';

interface Props {
  players: Player[];
}

const PlayersTab: React.FC<Props> = ({ players }) => (
  <div className="gd-players__grid">
    {players.map((p, index) => (
      <div key={index} className="gd-players__card">
        <span className="gd-players__avatar">
          {p.playerIcon ? p.playerIcon : '😎'}
        </span>
        <div className="gd-players__info">
          <span className="gd-players__name">{p.playerName}</span>
          <span className="gd-players__rank">Rank #{index}</span>
        </div>
        <span className="gd-players__score">
          {p.totalPoints.toLocaleString()}
        </span>
      </div>
    ))}
  </div>
);

export default PlayersTab;
